import Splide from '@splidejs/splide';
import {Fancybox} from "@fancyapps/ui";

document.addEventListener('DOMContentLoaded', function () {
    splide_carousel();
});

export function splide_carousel() {
    const carousels = document.querySelectorAll('.wp-block-gallery');

    if (carousels) {
        carousels.forEach((carousel, index) => {
            const carouselNr = index + 1;

            const track = document.createElement('div');
            const list = document.createElement('div');
            const fullScreenButton = document.createElement('div');
            const itemsToWrap = carousel.querySelectorAll('[class^="wp-block-image"]');
            const fancyboxSlides = [];

            carousel.classList.add('splide');

            list.classList.add('splide__list');

            carousel.insertBefore(list, itemsToWrap[0]);

            carousel.appendChild(fullScreenButton);

            fullScreenButton.classList.add('splide__fullscreen');
            fullScreenButton.setAttribute('data-fancybox-gallery-id', 'gallery-' + carouselNr);
            fullScreenButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87L327 41c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"/></svg>';

            itemsToWrap.forEach(item => {
                list.appendChild(item);
                item.classList.add('splide__slide');
                item.setAttribute('data-fancybox', 'gallery-' + carouselNr);

                const img_element = item.querySelector('img');
                const caption_element = item.querySelector('figcaption');

                if (img_element) {
                    const href = img_element.getAttribute('src');

                    item.setAttribute('data-src', href);

                    fancyboxSlides.push({
                        src: href,
                        type: 'image',
                        caption: caption_element ? caption_element.innerHTML : ""
                    });
                }
            });
            track.classList.add('splide__track');

            carousel.insertBefore(track, list);

            track.appendChild(list);

            new Splide(carousel , {
                type: 'slide',
                pagination: 'true',
                rewind: true,
                keyboard: 'global',
                accessibility: true,
                autoplay: true,
                pauseOnHover: true, // Pause on hover
                pauseOnFocus: true,
                perPage: 1,
                drag: 'free',
                lazyLoad: 'nearby',
                width: '1150px',
                height: '720px',
                heightRatio: '0.5',
                breakpoints: {
                    992: {
                        width: '660px',
                        height: '413px',
                    },
                    768: {
                        width: '480px',
                        height: '300px',
                    }
                }
            }).mount();

            Fancybox.bind("[data-fancybox]", {
                Toolbar: {
                    enabled: false
                },
                Carousel: {
                    formatCaption: (_carouselRef, slide) => {
                        let caption = slide.triggerEl?.getElementsByTagName('figcaption')[0];
                        return caption ? caption.innerHTML : "";
                    },
                },
            });

            fullScreenButton.addEventListener('click', function(event) {
                const galleryId = this.getAttribute('data-fancybox-gallery-id');
                const list = [...document.querySelectorAll('figure[data-fancybox="' + galleryId + '"]')];
                const active = document.querySelector('figure[data-fancybox="' + galleryId + '"].is-active');
                let currentIndex = list.indexOf(active);

                Fancybox.show(fancyboxSlides, {
                    Toolbar: {
                        enabled: false,
                    },
                    startIndex: currentIndex
                });
            });

            document.querySelectorAll('.splide__pagination button').forEach((button, index) => {
                button.setAttribute('aria-label', `Go to slide ${index + 1}`);
            });
        });
    }
}
